import { useEffect, useRef } from "react";

const ProgressWrap = () => {
  const progressWrapRef = useRef<HTMLDivElement>(null);
  const progressPathRef = useRef<SVGPathElement>(null);

  useEffect(() => {
    const progressWrap = progressWrapRef.current;
    const progressPath = progressPathRef.current;
    
    if (progressWrap && progressPath) {
      const pathLength = progressPath.getTotalLength();
      const offset = 50;
      
      // Set initial styles
      progressPath.style.transition = progressPath.style.webkitTransition = 'none';
      progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
      progressPath.style.strokeDashoffset = pathLength.toString();
      progressPath.getBoundingClientRect();
      progressPath.style.transition = progressPath.style.webkitTransition = 'stroke-dashoffset 10ms linear';

      const handleScroll = () => {
        const scroll = document.body.scrollTop || document.documentElement.scrollTop;
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const progress = pathLength - (scroll * pathLength / height);
        progressPath.style.strokeDashoffset = progress.toString();
        
        const scrollElementPos = document.body.scrollTop || document.documentElement.scrollTop;
        if (scrollElementPos >= offset) {
          progressWrap.classList.add("active-progress");
        } else {
          progressWrap.classList.remove("active-progress");
        }
      };

      const handleClick = (e: Event) => {
        e.preventDefault();
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      };

      window.addEventListener("scroll", handleScroll);
      progressWrap.addEventListener('click', handleClick);

      return () => {
        window.removeEventListener("scroll", handleScroll);
        progressWrap.removeEventListener('click', handleClick);
      };
    }
  }, []);

  return (
    <div ref={progressWrapRef} className="progress-wrap">
      <svg
        className="progress-circle svg-content"
        width="100%"
        height="100%"
        viewBox="-1 -1 102 102"
      >
        <path
          ref={progressPathRef}
          d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
          stroke="#06A87D"
          strokeWidth="5"
          fill="none"
        />
      </svg>
    </div>
  );
};

export default ProgressWrap;
